export class Menu {
  #htmlElement;
  #menu;

  constructor() {
    this.#menu = document.querySelector('.menu');
    if (!this.#menu) return;
    this.#htmlElement = document.documentElement;
    this.#bindEvents();
  }

  /**
   * Open or close menu.
   */
  #toggleMenu = e => {
    if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
      const action = e.currentTarget.dataset.menu;

      if (action === 'open') this.#htmlElement.classList.add('menu-open');
      else if (action === 'close') this.#htmlElement.classList.remove('menu-open');
      else if (action === 'toggle') this.#htmlElement.classList.toggle('menu-open');

      /* Set focus and tabindex attributes for keyboard accessibility. */
      const menuButton = this.#menu.querySelector('.menu-button');

      if (this.#htmlElement.classList.contains('menu-open')) {
        this.#menu.setAttribute('tabindex', '-1');
        if (menuButton) menuButton.setAttribute('tabindex', '0');
        this.#menu.focus();
      }
      else {
        this.#menu.removeAttribute('tabindex');
        if (menuButton) menuButton.removeAttribute('tabindex');
        const menuItemLink = document.querySelector('.item--menu'); // Assumes this is the original toggle button
        if (menuItemLink) menuItemLink.focus();
      }
    }
  };

  #bindEvents() {
    document.querySelectorAll('[data-menu]').forEach(el => {
      el.addEventListener('click', this.#toggleMenu);
      el.addEventListener('keydown', this.#toggleMenu);
    });
  }
}
